function n(t, $) {
  return t === ":host" ? `${t}(${$})` : `${t}${$}`;
}
function o(t, $) {
  return t === ":host" ? `${t}(${$})` : `:host(${$}) ${t}`;
}
export {
  o as hostSelectorState,
  n as selectorState
};
